import { Component, Inject, ViewContainerRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { OrdinalDateAdapter, ORD_DATE_FORMATS, OrdinalDateParse } from '../adapters/ordinal-date-adapter';
import { DataIdName } from '../entities/global/model';
import { GETInventoryService } from '../services/inventory.service';
import { RemoveImplementModalData } from './remove-implement-modal';
import { RemoveImplementModalService } from './remove-implement-modal.service';
import { AddRepairerWorkshopModalComponent } from '../add-repairer-workshop-modal/add-repairer-workshop-modal.component';
import { ErrorCode, ErrorMessages } from '../entities/global/error-codes';
import { NotificationsService } from 'angular2-notifications';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'remove-implement-modal',
    templateUrl: './remove-implement-modal.component.html',
    styleUrls: ['./remove-implement-modal.component.scss'],
    providers: [
        {
            provide: DateAdapter, useClass: OrdinalDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
        }
    ]
})

export class RemoveImplementModalComponent {
    jobsiteName: string;

    smu: number;
    cost: number;
    eventDate: Date;
    comment: string="";
    selectedRepairerId: number = 0;
    selectedWorkshopId: number = 0;

    ord: OrdinalDateParse = new OrdinalDateParse();

    minDate: Date = new Date();
    maxDate: Date = new Date();

    statusList: DataIdName[];
    repairerList: DataIdName[];
    workshopList: DataIdName[];
    removeImplementData: RemoveImplementModalData;
    savingChanges: boolean = false;

    showRepairerAndWorkshop: boolean = false;
    showAddWorkshop: boolean = false;

    // Tooltips
    ttDate: string = "Click here to select a date.";
    ttComment: string = "You may enter a maximum of 256 characters.";

    constructor(private _appService: AppService, public dialogRef: MatDialogRef<RemoveImplementModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public _moduleService: RemoveImplementModalService,
        public _inventoryService: GETInventoryService, public addRepairerWorkshopModal: MatDialog,
        public toastr: NotificationsService, vcr: ViewContainerRef) {
        
    }
    ngOnInit() {
        this.removeImplementData = new RemoveImplementModalData();
        this.removeImplementData.cost=0;
        this.eventDate = new Date();
        this.removeImplementData.date = this.eventDate;
        this.removeImplementData.comment="";
        if (this.data != null) {
            if (this.data.implementId != null) {
                this.removeImplementData.implementId = this.data.implementId;

                this._inventoryService.returnMinDateForImplementEvent(this.data.implementId)
                    .subscribe(response => {
                        if (response != "") {
                            try {
                                this.minDate = new Date(response);
                            }
                            catch (ex) {
                                this.minDate = new Date();
                            }
                        }
                    });
            }
            if (this.data.jobsiteId != null) {
                this.removeImplementData.jobsiteId = this.data.jobsiteId;

                if (this.data.jobsiteName != null) {
                    this.jobsiteName = this.data.jobsiteName;
                }

                this.reloadRepairerListForCustomer();
            }
            
            if (this.data.equipmentId != null) {
                this.removeImplementData.equipmentId = this.data.equipmentId;

                if (this.data.equipmentSMU != null) {
                    this.removeImplementData.smu = this.data.equipmentSMU;
                    this.smu = this.data.equipmentSMU;
                }
            }

            this._inventoryService.returnInventoryStatusList().subscribe(response => {
                this.statusList = response;
                console.log(response);
                this.statusList = this.statusList.filter(x=>x.Id!=6)
            }, error => { console.log(error); });
        }
    }
    reloadRepairerListForCustomer() {
        if (this.data.jobsiteId != null) {
            this._inventoryService.returnRepairerListForCustomer(this.data.jobsiteId).subscribe(response => {
                this.repairerList = response;

                if (this.selectedRepairerId != 0) {
                    this.repairerSelected(this.selectedRepairerId);
                }
            }, error => { console.log(error); });
        }
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }
    saveChanges(): void {
        if (this.savingChanges) {
            return;
        }
        if(this.removeImplementData.cost == null){
        this.removeImplementData.cost=0;
        }

        let validation = this.validateData();
        this.savingChanges = true;
        if (validation == ErrorCode.VALIDATION_PASSED) {
            this._moduleService.saveRemoveImplement(this.removeImplementData).subscribe(response => {
                if (response == "false") {
                    this.toastr.error(ErrorMessages.ERROR_SAVING);
                    this.savingChanges = false;
                }
                else {
                    this.dialogRef.close();
                }
            }, error => { console.log(error); });
        }
        else if (validation == ErrorCode.ERROR_NEGATIVE_COST) {
            this.toastr.error(ErrorMessages.ERROR_NEGATIVE_COST);
            this.savingChanges = false;
        }
        else if (validation == ErrorCode.ERROR_NEGATIVE_SMU) {
            this.toastr.error(ErrorMessages.ERROR_NEGATIVE_SMU);
            this.savingChanges = false;
        }
        else {
            this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
            this.savingChanges = false;
        }
    }
    validateData(): number {
        var returnCode =  ErrorCode.VALIDATION_PASSED;

        if (this.removeImplementData.equipmentId
            && this.removeImplementData.jobsiteId
            && this.removeImplementData.smu
            && this.removeImplementData.cost
            && this.removeImplementData.date
            && this.removeImplementData.status
            && this.removeImplementData.comment) {

            if (this.removeImplementData.cost < 0) {
                console.log("1111")
                returnCode = ErrorCode.ERROR_NEGATIVE_COST;
            }
            else if (this.removeImplementData.smu < 0) {
                console.log("2222")
                returnCode = ErrorCode.ERROR_NEGATIVE_SMU;
            }
            //TT-5935: Asked to hide repair and location for all the status
            // else if ((this.removeImplementData.repairerId == 0
            //     || this.removeImplementData.workshopId == 0)
            //     && this.showRepairerAndWorkshop) {
            //         console.log("3333")
            //     returnCode = ErrorCode.ERROR_MISSING_FIELDS;
            // }
            else {
                returnCode = ErrorCode.VALIDATION_PASSED;
            }
        }

        return returnCode;
    }

    // Status
    statusSelected(statusId): void {
        this.removeImplementData.status = statusId;
        this.removeImplementData.repairerId = 0;
        this.removeImplementData.workshopId = 0;
        this.showRepairerAndWorkshop = false;

        this._inventoryService.checkIfRepairerRequiredForStatus(statusId).subscribe(response => {
            if (response == true) {
                this.showRepairerAndWorkshop = true;
            }
        }, error => { console.log(error); });
    }

    // Repairer
    repairerSelected(repairerId): void {
        this.selectedRepairerId = repairerId;
        this.removeImplementData.repairerId = repairerId;

        this._inventoryService.returnWorkshopListForRepairer(repairerId).subscribe(response => {
            this.workshopList = response;
            this.showAddWorkshop = true;

            if (this.selectedWorkshopId != 0) {
                this.workshopSelected(this.selectedWorkshopId);
            }
        }, error => { console.log(error); });
    }

    // Workshop
    workshopSelected(workshopId): void {
        this.selectedWorkshopId = workshopId;
        this.removeImplementData.workshopId = workshopId;
    }

    // SMU
    smuChanged(): void {
        this.removeImplementData.smu = this.smu;
    }
    // Cost
    costChanged(): void {
        this.removeImplementData.cost = this.cost;
    }

    // Date
    dateChanged(): void {
        this.removeImplementData.date = this.eventDate;
        this.ord.formatDateOrdinal((this.eventDate.toString())
            .split(' ')
            .slice(1)
            .join(' '), false);
    }

    // Comment
    commentChanged(): void {
        this.removeImplementData.comment = this.comment;
    }

    // Add repairer and workshop
    addRepairer(): void {
        this._inventoryService.setRepairerId(0);
        let addRepairerWorkshopModalRef = this.addRepairerWorkshopModal.open(AddRepairerWorkshopModalComponent, {
            width: '550px',
            data: {
                jobsiteId: this.removeImplementData.jobsiteId,
                jobsiteName: this.jobsiteName
            }
        });
        addRepairerWorkshopModalRef.afterClosed().subscribe(() => {
            this.reloadRepairerListForCustomer();
            this.selectedRepairerId = this._inventoryService.getRepairerId();
            this.removeImplementData.repairerId = this.selectedRepairerId;
        });
    }
    addWorkshop(): void {
        this._inventoryService.setWorkshopId(0);
        let addRepairerWorkshopModalRef = this.addRepairerWorkshopModal.open(AddRepairerWorkshopModalComponent, {
            width: '550px',
            data: {
                jobsiteId: this.removeImplementData.jobsiteId,
                jobsiteName: this.jobsiteName,
                repairerId: this.removeImplementData.repairerId
            }
        });
        addRepairerWorkshopModalRef.afterClosed().subscribe(() => {
            this.reloadRepairerListForCustomer();
            this.selectedWorkshopId = this._inventoryService.getWorkshopId();
            this.removeImplementData.workshopId = this.selectedWorkshopId;
        });
    }
}
